import React from 'react'

function Third() {
  return (
    <section className='third'>
        <h1>PayZone Special Event - Unlocking Global Opportunities</h1>
        <p>Our launch in the United States, the global partnership with Burna Boy, and Twitter Tips integration are all steps in our journey to make sending money to, from, and across Africa easy, accessible, and maybe even fun. Watch the full event.</p>
        <div className="img">
            
        </div>
    </section>
  )
}

export default Third